<template>
    <div class="container">
        <div
            v-if="!hasPerson || user.submitting"
            class="row mb"
            data-qa="person-loading"
        >
            <div class="col-12 col-md-12 col-lg-8">
                <h2>{{
                    t('Profile.PersonalData.ProfileOverview.Subline.Personal')
                }}</h2>
            </div>
            <div class="col-12 col-md-12 col-lg-8 align-center">
                <p>{{ t('General.IsLoading') }}</p>
                <CrefoRingLoading />
            </div>
        </div>
        <div v-if="hasPerson && !user.submitting">
            <div class="row mb-large">
                <div class="col-12 col-md-12 col-lg-8">
                    <h2>{{
                        t(
                            'Profile.PersonalData.ProfileOverview.Subline.Personal'
                        )
                    }}</h2>
                    <PersonalDataForm />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h2>{{
                        t(
                            'Profile.PersonalData.ProfileOverview.SectionEmail.Headline'
                        )
                    }}</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <p
                        class="mb-large text-ellipsis"
                        data-qa="person-mail-address"
                    >
                        {{ user.user.email }}
                    </p>
                </div>
                <div class="col-6">
                    <router-link
                        :to="{ name: 'change-mail-address' }"
                        class="btn btn-default"
                        data-qa="change-mail-address-button"
                    >
                        {{
                            t(
                                'Profile.PersonalData.ProfileOverview.SectionEmail.ButtonText'
                            )
                        }}
                    </router-link>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h2>{{
                        t(
                            'Profile.PersonalData.ProfileOverview.SectionPassword.Headline'
                        )
                    }}</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <p class="mb-large">********</p>
                </div>
                <div class="col-6">
                    <router-link
                        :to="{ name: 'change-password' }"
                        class="btn btn-default"
                        data-qa="change-password-button"
                    >
                        {{
                            t(
                                'Profile.PersonalData.ProfileOverview.SectionPassword.ButtonText'
                            )
                        }}
                    </router-link>
                </div>
            </div>
            <div v-if="!isMitgliedsUser" class="row">
                <div class="col-6 offset-6">
                    <router-link
                        :to="{ name: 'request-account-deletion' }"
                        class="btn btn-default bg-brand-red btn-delete-account"
                        data-qa="delete-account-button"
                    >
                        {{
                            t(
                                'Profile.PersonalData.ProfileOverview.DeleteAccount.ButtonText'
                            )
                        }}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { onMounted, watch } from 'vue'
import PersonalDataForm from '@/components/forms/selfcare/person/form'
import CrefoRingLoading from '@/components/helper/ring-loading'
import { useUserStore } from '@/store/module-user.js'
import { storeToRefs } from 'pinia'

const store = useUserStore()
const router = useRouter()
const { t } = useI18n()
const { getUser: user, isMitgliedsUser, hasPerson } = storeToRefs(store)

onMounted(() => {
    store.getPersonMe()

    watch(
        () => store.user.patchPerson.success,
        newProps => {
            if (newProps) {
                router.push({ name: 'patch-person-success' })
            }
        }
    )

    watch(
        () => store.user.patchPerson.error,
        newProps => {
            if (newProps !== null && typeof newProps !== 'undefined') {
                store.toggleDialog({
                    show: !user.value.failureDialog.show,
                    error: newProps,
                    dataQa: 'patch-person-error-dialog'
                })
            }
        }
    )
})
</script>

<style lang="less">
    .input-slot:hover {
        .calendar2.grey {
            background-image: url(../../../assets/app-icons/icon-calendar2-rgb-cyan.svg) !important;
        }
    }

    .text-ellipsis {
        white-space: nowrap;
        width: 100%; /* IE6 needs any width */
        overflow: hidden; /* "overflow" value must be different from  visible"*/
        -o-text-overflow: ellipsis; /* Opera < 11*/
        text-overflow: ellipsis;
    }

    .btn-delete-account {
        margin-bottom: 30px;
        margin-top: 45px;
    }

    .align-center {
        text-align: center;
    }
</style>
